import { JobTypes } from 'src/modules/jobs';
import moment from 'moment';
import 'moment/locale/de';

export const getJobLocationRow = (city, intl) => {
  if (!city) return null;
  return `${intl.formatMessage({ id: 'page/careers/details/location' })}: ${city?.name}, ${
    city?.country?.name
  }`;
};

export const getJobTypeRow = (type, intl) => {
  const {
    FullTime,
    PartTime,
    Internship,
    DegreeProgram,
    IndustrialTraining,
    BusinessManagement,
  } = JobTypes;

  let typeText: string;
  switch (type) {
    case FullTime:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_fulltime' });
      break;
    case PartTime:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_parttime' });
      break;
    case Internship:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_internship' });
      break;
    case DegreeProgram:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_degree_program' });
      break;
    case IndustrialTraining:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_industrial_training' });
      break;
    case BusinessManagement:
      typeText = intl.formatMessage({ id: 'page/careers/details/type_business_management' });
      break;
  }

  return `${intl.formatMessage({ id: 'page/careers/details/type' })}: ${typeText}`;
};

export const getJobDateRow = (start_date, locale, intl) => {
  moment.locale(locale);
  const startDate = moment(start_date);
  const currentDate = moment();
  return `${intl.formatMessage({ id: 'page/careers/details/date' })}: 
    ${
      currentDate.diff(startDate, 'months', true) < 0 // && startDate.get('month') !== currentDate.get('month')
        ? startDate.format('MMMM YYYY')
        : intl.formatMessage({ id: 'page/careers/details/date_now' })
    }`;
};
